module.exports = __webpack_public_path__ + "static/media/Iqvia.71958aa7.jpg";